export const setCTIDAssets = (assets, source_ctid, base_url = "") => ({
  type: "SET_CTID_ASSETS",
  ctidAssets: assets,
  import_source_ctid: source_ctid,
  import_base_url: base_url,
});

export const setSelectedAssets = (assets) => ({
  type: "SET_SELECTED_ASSETS",
  assetsToImport: assets,
});

export const searchAddTableValues = (searchValue) => ({
  type: "SEARCH_ADD_ASSETS_TABLE_VALUES",
  searchValue: searchValue,
});

export const searchUpdatedTableValues = (searchValue) => ({
  type: "SEARCH_UPDATED_ASSETS_TABLE_VALUES",
  searchValue: searchValue,
});

export const setNewDate = (whatToSet, dateString, roundUp = true) => ({
  type: "SET_IMPORT_DATE",
  whatToSet: whatToSet,
  dateString: dateString,
  roundUp: roundUp,
});

export const setNewTime = (whatToSet, timeString, timeZoneOverride) => ({
  type: "SET_IMPORT_TIME",
  whatToSet: whatToSet,
  timeString: timeString,
  timeZoneOverride: timeZoneOverride,
});

export const setError = (error) => ({
  type: "SET_IMPORT_ERROR",
  error: error,
});

export const setSearchFilter = (filters, idKey) => ({
  type: "SET_SEARCH_FILTER",
  filters: filters,
  idKey: idKey,
});
